// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.component-catalog-modal {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.component-catalog-modal .modal-header {
  border: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 16px 24px;
  flex-shrink: 0;
}
.component-catalog-modal .modal-header h2 {
  grid-column: 2;
  margin: 0;
  font-size: 2rem;
  font-weight: 500;
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  text-transform: lowercase;
}
.component-catalog-modal .modal-header button {
  grid-column: 3;
  justify-self: end;
  color: #666;
}
.component-catalog-modal .modal-header button:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.04);
}
.component-catalog-modal .modal-content {
  border: 0;
  flex: 1 1 auto;
  min-height: 0;
  max-height: calc(100% - 140px);
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: auto;
}
.component-catalog-modal .modal-content .embedded-catalog,
.component-catalog-modal .modal-content .standard-catalog {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  overflow: hidden;
}
.component-catalog-modal .modal-content .embedded-catalog .search-container,
.component-catalog-modal .modal-content .embedded-catalog .filters-container,
.component-catalog-modal .modal-content .standard-catalog .search-container,
.component-catalog-modal .modal-content .standard-catalog .filters-container {
  flex-shrink: 0;
}
.component-catalog-modal .modal-content .embedded-catalog mat-table,
.component-catalog-modal .modal-content .standard-catalog mat-table {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}
.component-catalog-modal .modal-content .embedded-catalog app-component-catalog,
.component-catalog-modal .modal-content .embedded-catalog ::ng-deep app-component-catalog {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.component-catalog-modal .modal-content .embedded-catalog ::ng-deep app-mat-paginator-go-to {
  flex-shrink: 0;
}
.component-catalog-modal .modal-content .embedded-catalog ::ng-deep .middle-container {
  align-items: stretch;
}
.component-catalog-modal .modal-content .embedded-catalog ::ng-deep .filter-group-container {
  overflow-y: auto;
}
.component-catalog-modal .search-filters-section {
  margin-bottom: 16px;
}
.component-catalog-modal .search-filters-section .search-bar {
  margin-bottom: 16px;
}
.component-catalog-modal .search-filters-section .search-bar .search-field {
  width: 100%;
  max-width: 400px;
}
.component-catalog-modal .search-filters-section .filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}
.component-catalog-modal .search-filters-section .filters-row .filter-field {
  min-width: 150px;
  max-width: 200px;
}
.component-catalog-modal .search-filters-section .filters-row .clear-filters-btn {
  height: 40px;
  margin-top: 4px;
}
.component-catalog-modal .results-info-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.component-catalog-modal .results-info-section .results-info {
  font-size: 14px;
  color: #666;
}
.component-catalog-modal .results-info-section .results-info .selected-count {
  font-weight: 500;
  color: #1976d2;
}
.component-catalog-modal .results-info-section .selection-actions {
  display: flex;
  gap: 8px;
}
.component-catalog-modal .results-info-section .selection-actions button {
  font-size: 12px;
  padding: 4px 12px;
}
.component-catalog-modal .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
}
.component-catalog-modal .loading-container mat-spinner {
  margin-bottom: 16px;
}
.component-catalog-modal .results-table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.component-catalog-modal .results-table-container table {
  width: 100%;
}
.component-catalog-modal .results-table-container table .select-column {
  width: 50px;
  padding-right: 16px;
}
.component-catalog-modal .results-table-container table .code-column {
  width: 120px;
  font-family: "Courier New", monospace;
}
.component-catalog-modal .results-table-container table .description-column {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.component-catalog-modal .results-table-container table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #e0e0e0;
}
.component-catalog-modal .results-table-container table td {
  border-bottom: 1px solid #f0f0f0;
}
.component-catalog-modal .results-table-container table .selected-row {
  background-color: #e3f2fd;
}
.component-catalog-modal .results-table-container table tr:hover {
  background-color: #f5f5f5;
}
.component-catalog-modal .results-table-container mat-paginator {
  border-top: 1px solid #e0e0e0;
  flex-shrink: 0;
}
.component-catalog-modal .results-table-container .no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
  text-align: center;
}
.component-catalog-modal .results-table-container .no-results mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  color: #ddd;
}
.component-catalog-modal .results-table-container .no-results h3 {
  margin: 0 0 8px 0;
  font-weight: 400;
}
.component-catalog-modal .results-table-container .no-results p {
  margin: 0;
  font-size: 14px;
}
.component-catalog-modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;
  z-index: 10;
}
.component-catalog-modal .modal-actions button {
  min-width: 120px;
}
.component-catalog-modal .cancel-btn {
  border: 1px solid #0066b2;
  color: #0066b2;
  background-color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.component-catalog-modal .cancel-btn:hover {
  background-color: rgba(0, 102, 178, 0.04);
}

@media (max-width: 768px) {
  .component-catalog-modal {
    width: 100vw;
    height: 100vh;
    max-width: none;
  }
  .component-catalog-modal .search-filters-section .filters-row {
    flex-direction: column;
    align-items: stretch;
  }
  .component-catalog-modal .search-filters-section .filters-row .filter-field {
    max-width: none;
  }
  .component-catalog-modal .results-info-section {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  .component-catalog-modal .modal-actions {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  .component-catalog-modal .modal-actions .actions-left,
  .component-catalog-modal .modal-actions .actions-right {
    justify-content: center;
  }
}
.dark-theme .component-catalog-modal .modal-header {
  border-bottom-color: #424242;
}
.dark-theme .component-catalog-modal .modal-header h2 {
  color: #64b5f6;
}
.dark-theme .component-catalog-modal .results-info-section {
  border-bottom-color: #424242;
}
.dark-theme .component-catalog-modal .results-table-container table th {
  background-color: #2a2a2a;
  color: #fff;
  border-bottom-color: #424242;
}
.dark-theme .component-catalog-modal .results-table-container table td {
  border-bottom-color: #424242;
}
.dark-theme .component-catalog-modal .results-table-container table .selected-row {
  background-color: #1e3a5f;
}
.dark-theme .component-catalog-modal .results-table-container table tr:hover {
  background-color: #333;
}
.dark-theme .component-catalog-modal .results-table-container mat-paginator {
  border-top-color: #424242;
}
.dark-theme .component-catalog-modal .modal-actions {
  border-top-color: #424242;
  background-color: #2a2a2a;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
